<div class="navbar-container">
  <!-- Top navbar -->
  <dbs-header></dbs-header>

  <mat-sidenav-container class="navbar-sidenav-container" autosize>
    <!-- Side nav -->
    <mat-sidenav #sidenav [opened]="!mobileQuery.matches" [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" class="sidenav" [disableClose]="true">
      <dbs-sidebar-menu [isSdMenu]="isSdMenu"></dbs-sidebar-menu>
    </mat-sidenav>

    <!-- Main content -->
    <mat-sidenav-content class="sidenav-content">
      <ng-content select="router-outlet"></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>

</div>
